import meta from '../metas/upload';
export default {
  meta,
  data: () => ({
    action: '/upload'
  })
};